import DashboardHeader from "../dashboard/dashboardHeader";

const SysadminHeader = () => {
  return (
    <DashboardHeader /> // using DashboardHeader component as SysadminHeader
  );
};

export default SysadminHeader;
